import StoreUtil from '@/store/utils'
import DeepDiff from 'deep-diff'
import PurchaseOrderRoutes from './route-types'
// import Guid from '@/components/Guid'
import PurchaseOrderService from './PurchaseOrderService'
import { md5 } from '@/components/crypto'
import store from '@/store'

const tag = 'purchaseorder'

const getUser = function () {
 const user = store.getters['userInfo/user']
 return user
}

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: [],
  readOnlyView: false,
  isLockPurchaseOrder: false
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: state => state.snapshots,
  baseSnapshot: state => state.snapshots[state.baseIndex],
  currentSnapshot: state => state.snapshots[state.currentIndex],
  snapshotDiff: state => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  },
  readOnlyView: state => state.readOnlyView,
  isLockPurchaseOrder: state => state.isLockPurchaseOrder
}

const actions = {
  async getStoreItem({ commit }, id) {
    // const entity = StoreUtil.getStorage(id, tag) || (await QuickInvoiceService.getEntity(id, ''))
    // The following for refreshing data from WebApi regardless
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity || (entity && !entity.isNew)) {
      const hash = entity ? md5(JSON.stringify(entity)) : ''
      const data = await PurchaseOrderService.getEntity(id, hash)
      if (data) {
        console.log('from WebApi')
        // data.purchaseOrderDate = data.purchaseOrderDate.split('.')[1] ? data.purchaseOrderDate.split('.')[0] + 'Z' : data.purchaseOrderDate
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    StoreUtil.setStorage(entity.purchaseOrderId, tag, entity)
    commit('saveInitialSnapshots', entity)
    const user = getUser()
    commit('setLockPurchaseOrder', entity.partsCheckPurchaseOrderNo.length != 0 && !user.info.isSupportUser)
  },
  async addStoreItem({ commit }) {
    const entity = await PurchaseOrderService.getNewEntity()
    // const utcDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()
    // entity.invoiceDate = utcDate.split('.')[0] + 'Z'
    StoreUtil.setStorage(entity.purchaseOrderId, tag, entity)
    // console.log(entity)
    commit('saveInitialSnapshots', entity)
    StoreUtil.routeToDetail(PurchaseOrderRoutes.PurchaseOrderListView.path, entity.purchaseOrderId, true)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setVendor({ commit, state }, updateModel) {
    commit('setVendor', updateModel)
  },
  setContact({ commit, state }, updateModel) {
    commit('setContact', updateModel)
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  },
  setReadOnlyView({ commit }, value) {
    commit('setReadOnlyView', value)
  },
  setLockPurchaseOrder({ commit }, value) {
    commit('setLockPurchaseOrder', value)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setVendor(state, updateModel) {
    const curPO = state.snapshots[state.currentIndex]
    curPO.vendorId = updateModel.vendor.key
  },
  setContact(state, updateModel) {
    const curPO = state.snapshots[state.currentIndex]
    curPO.contactId = updateModel.contact.key
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  },
  setReadOnlyView(state, value) {
    state.readOnlyView = value
  },
  setLockPurchaseOrder(state, value) {
    state.isLockPurchaseOrder = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
